import {
	ApplyConsolidationMutation,
	SetConsolidationRuleSetMutation
} from "~/gql/mutations/produce/consolidation.generated";
import {
	GetConsolidationPreviewQuery,
	GetConsolidationRuleSetQuery
} from "~/gql/queries/produce/consolidation.generated";

export const consolidationEndpoints = {
	ApplyConsolidation: {
		invalidatesTags: ["ProductionLots", "ProductionJobs", "SpaceUtilization", "ConsolidationPreview"] as AddTagTypes,
		transformResponse: (res: ApplyConsolidationMutation) => res
	},
	GetConsolidationPreview: {
		providesTags: ["ConsolidationPreview"] as AddTagTypes,
		transformResponse: (res: GetConsolidationPreviewQuery) => res
	},
	GetConsolidationRuleSet: {
		providesTags: ["ConsolidationRuleSet"] as AddTagTypes,
		transformResponse: (res: GetConsolidationRuleSetQuery) => res
	},
	SetConsolidationRuleSet: {
		invalidatesTags: ["ConsolidationRuleSet", "ConsolidationPreview"] as AddTagTypes,
		transformResponse: (res: SetConsolidationRuleSetMutation) => res
	}
};
